import { styled } from "styled-components";

export const MyInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 32px;

  width: 600px;
`;
